import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default class RecentEvent extends React.Component {

    render() {

        const event = this.props.event;
        let dotClass = 'dot--white';
        if (event.eventCategory === 'giftcard') {
            dotClass = 'dot--purple';
        }
        else if (event.eventCategory === 'member') {
            dotClass = 'dot--blue';
        }
        else if (event.eventCategory === 'new-member') {
            dotClass = 'dot--green';
        }

        /*<li>
            <Link to="/giftcards/605863485481103102321">
                <span className="dot dot--purple" />
                <p className="text--11 f-right">Gift Card Lookup</p>
                <p className="text--13"><strong>605863485481103102321</strong><br />$10.00</p>
            </Link>
        </li>
        <li>
            <Link to="/members?q=Lee%20@humaan">
                <span className="dot dot--blue" />
                <p className="text--11 f-right">Member Lookup</p>
                <p className="text--13"><strong>Lee @humaan</strong></p>
            </Link>
        </li>*/

        const urlParts = event.targetUrl ? event.targetUrl.split('?') : [''];

        const parseURLString = (str) => str.replace(/=([^&]*)/, (rep) => `=${encodeURIComponent(rep.replace('=', ''))}`);

        const endpoint = urlParts[0];
        const query = urlParts.length > 1 ? '?' + urlParts.slice(1).map(parseURLString).join('') : '';
        const url = `${endpoint}${query}`;
        return (
            <li>
                <Link to={url}>
                    <span className={"dot " + dotClass} />
                    <p className="text--11 f-right">{event.eventName}</p>
                    <p className="text--13"><strong>{event.description}</strong><br />{event.detail}</p>
                </Link>
            </li>
        )
    }
}

RecentEvent.propTypes = {
    event: PropTypes.object.isRequired
};
